module.exports = __webpack_public_path__ + "img/ttf.a7b32e45.svg";